import * as dataParsing from './dataParsing';
import * as textParsing from './textParsing';
import * as validation from './validation';

export * from './fieldMatchUtils.constants';

export const fieldsMatchUtils = {
  ...dataParsing,
  ...textParsing,
  ...validation,
};

export default fieldsMatchUtils;
